/**
 * Application Form Translations - Portuguese (PT-BR)
 */
export const applicationPt = {
  // Modal
  'application.modal.title': 'Candidatar-se para a Vaga',
  'application.modal.closeAriaLabel': 'Fechar formulário de candidatura',
  'application.modal.description': 'Formulário de candidatura. Este é um processo de múltiplas etapas onde você fornecerá suas informações de contato, enviará seu currículo e revisará sua candidatura.',

  // Step titles
  'application.steps.contactInfo': 'Informações de Contato',
  'application.steps.uploadCv': 'Enviar Currículo',
  'application.steps.review': 'Revisar e Enviar',

  // Candidate info form (Step 1)
  'application.form.fullName': 'Nome Completo',
  'application.form.fullNamePlaceholder': 'Seu nome completo',
  'application.form.email': 'E-mail',
  'application.form.emailPlaceholder': 'seu.email@exemplo.com',
  'application.form.phone': 'Telefone',
  'application.form.phonePlaceholder': '+55 11 98765-4321',
  'application.form.linkedIn': 'URL do LinkedIn',
  'application.form.linkedInPlaceholder': 'https://linkedin.com/in/seunome',

  // Validation messages
  'application.validation.fullNameRequired': 'Por favor, insira seu nome completo',
  'application.validation.emailInvalid': 'Por favor, insira um e-mail válido',
  'application.validation.phoneInvalid': 'Por favor, insira um telefone válido com código do país (ex: +55 11 98765-4321)',
  'application.validation.linkedInInvalid': 'Por favor, insira uma URL válida (ex: https://linkedin.com/in/seunome)',

  // CV Upload (Step 2)
  'application.upload.dragDrop': 'Arraste e solte seu currículo aqui, ou clique para selecionar',
  'application.upload.fileTypes': 'Apenas arquivos PDF, DOC ou DOCX (máx 10MB)',
  'application.upload.preparing': 'Preparando envio...',
  'application.upload.uploading': 'Enviando...',
  'application.upload.success': 'Enviado com sucesso',
  'application.upload.retryButton': 'Tentar Novamente',
  'application.upload.dropzoneAriaLabel': 'Clique ou arraste e solte para enviar currículo',
  'application.upload.progressAriaLabel': 'Progresso do envio: {{percent}}%',

  // Upload errors
  'application.upload.error.invalidType': 'Tipo de arquivo inválido. Envie um arquivo PDF, DOC ou DOCX.',
  'application.upload.error.invalidFormat': 'Formato de arquivo inválido. Envie um arquivo PDF, DOC ou DOCX.',
  'application.upload.error.tooLarge': 'O arquivo deve ter menos de 10MB.',
  'application.upload.error.failed': 'Falha no envio. Por favor, tente novamente.',
  'application.upload.error.network': 'Erro de rede. Verifique sua conexão e tente novamente.',
  'application.upload.error.timeout': 'O envio expirou. Por favor, tente novamente.',
  'application.upload.error.expired': 'URL de envio expirou. Por favor, tente novamente.',
  'application.upload.error.server': 'Erro no servidor. Por favor, tente novamente.',

  // Review (Step 3)
  'application.review.contactInfo': 'Informações de Contato',
  'application.review.fullName': 'Nome Completo',
  'application.review.email': 'E-mail',
  'application.review.phone': 'Telefone',
  'application.review.linkedIn': 'Perfil LinkedIn',
  'application.review.cv': 'Currículo',
  'application.review.editContactAriaLabel': 'Editar informações de contato',
  'application.review.editCvAriaLabel': 'Editar currículo',
  'application.review.readyToSubmit': 'Pronto para enviar?',
  'application.review.readyToSubmitDescription': 'Revise suas informações acima. Após o envio, não será possível alterar esta candidatura.',
  'application.review.missingInfo': 'Informações obrigatórias ausentes. Por favor, complete as etapas anteriores.',
  'application.review.submitButton': 'Enviar Candidatura',
  'application.review.submittingButton': 'Enviando...',
  'application.review.submitAriaLabel': 'Enviar candidatura',
  'application.review.submittingAriaLabel': 'Enviando candidatura',

  // Submission errors
  'application.submit.error.missingInfo': 'Informações obrigatórias ausentes. Por favor, complete todas as etapas.',
  'application.submit.error.duplicate': 'Você já se candidatou para esta vaga.',
  'application.submit.error.invalidData': 'Dados inválidos. Por favor, verifique suas informações.',
  'application.submit.error.notAvailable': 'Esta vaga não está mais disponível.',
  'application.submit.error.server': 'Erro no servidor. Por favor, tente novamente mais tarde.',
  'application.submit.error.generic': 'Falha ao enviar candidatura. Por favor, tente novamente.',

  // Success message
  'application.success.title': 'Candidatura enviada com sucesso!',
  'application.success.subtitle': 'Estamos animados para conhecer você. Fique de olho no seu e-mail!',
  'application.success.nextStepsTitle': 'Próximos passos',
  'application.success.nextStepsDescription': 'Vamos analisar sua candidatura e entraremos em contato em até 5 dias úteis caso queiramos avançar.',
  'application.success.closeAriaLabel': 'Fechar mensagem e voltar para a vaga',
}
